// extracted by mini-css-extract-plugin
module.exports = {"webspace-select":"webspace-select--1e8JLprbA5","webspaceSelect":"webspace-select--1e8JLprbA5"};